

























import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";
import { DraggingOffsets, Point, Rectangle, Size, Vector } from "../../../../../base/domain/drawing";
import { IQuestionnaire } from "../../../../../documaker/domain/format/objects";
import { IEditableFormatObject, IFormatObjectEditable } from "../../../../domain/editableFormat";
import { ElementTypes, instanceOfICheckableObject } from "../../../../domain/editableFormat/objects";
import { instanceOfIQuestionnairePropertyEditable } from "../../../../domain/editableFormat/properties";
import { default as FormatObjectDrawer } from "./FormatObjectDrawer.vue";
import { FormatStructureEditorStoreReferableMixin } from "../mixins";
import { QuestionnaireGuidTree } from "../../../../domain/questionnaire";
import { QuestionnaireFormatObject } from "../../../../domain/questionnaire/constants";

@Component({
  components: {
    FormatObjectDrawer,
  }
})
export default class QuestionnaireFormatObjectDrawer extends Mixins(ModelEditableMixin, FormatStructureEditorStoreReferableMixin) {
  @Prop()
  offsets: DraggingOffsets<IFormatObjectEditable>;

  @Prop({ default: 1 })
  scale: number;

  @Prop({ default: true })
  isHandleable: boolean;

  @Prop({ default: () => [] as IFormatObjectEditable[] })
  objects: IFormatObjectEditable[];

  @Prop({ default: () => [] as QuestionnaireGuidTree<IFormatObjectEditable>[] })
  treeItems: QuestionnaireGuidTree<IFormatObjectEditable>[];

  get geometryStyle() {
    const treeItem = this.treeItems.find(v => v.source === this.editingSource);
    const offset = (treeItem ? treeItem.level : 0) * QuestionnaireFormatObject.Gap;
    return {
      top: `${this.offsets.relocatingOffset.y}px`,
      left: `${this.offsets.relocatingOffset.x + offset}px`,
      width: `calc(100% - ${offset}px)`,
    };
  }

  get fixedOffsets(): DraggingOffsets<IFormatObjectEditable> {
    return new DraggingOffsets(this.offsets.source, new Point(0, 0), new Rectangle(new Point(1, 1), new Size(1, 1)), new Vector(new Point(0, 0), new Point(0, 0)));
  }

  get overview(): string {
    return this.editingSource.getOverview();
  }

  get prefixClass() {
    return [
      "prefix",
      this.isSameText() ? "same" : undefined,
    ];
  }

  private isSameText(): boolean {
    if (this.elementType !== "check") {
      return false;
    }
    const index = this.objects.findIndex(o => o === this.editingSource);
    if (index < 1) {
      return false;
    }
    const preSource = this.objects[index - 1].getSource();
    return preSource.elementName === "check"
      && instanceOfICheckableObject(preSource, preSource.elementName)
      && instanceOfICheckableObject(this.source, this.elementType)
      && preSource.informationKey === this.source.informationKey;
  }

  get prefix() {
    // 本来は辞書等で管理したいが数も知れてるので分岐で.
    return (this.questionnire && !["display", "group"].includes(this.questionnire.type))
      ? this.questionnire.text
      : "";
  }

  get suffix() {
    // 本来は辞書等で管理したいが数も知れてるので分岐で.
    return (this.questionnire && this.elementType === "check" && instanceOfICheckableObject(this.source, this.elementType))
      ? this.source.categoryName
      : "";
  }

  get questionnire(): IQuestionnaire {
    return instanceOfIQuestionnairePropertyEditable(this.editingSource)
      ? this.editingSource.questionnaire().getValue()
      : null;
  }

  get elementType(): ElementTypes {
    return this.source.elementName;
  }

  get source(): IEditableFormatObject {
    return this.editingSource.getSource();
  }

  get isSelected() {
    return this.editingSource.isSelected();
  }

  @Emit()
  mouseLeftDowned(event: PointerEvent) {}

  @Emit()
  mouseRightDowned(event: PointerEvent) {}

  @Emit()
  mouseDownCaptured(event: PointerEvent) {}

  @Emit()
  dragHandleSelected(event: PointerEvent) {}
}
